import React, {useEffect, useState} from 'react';
import {Button, Col, Image, Row} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Link, useLocation} from 'react-router-dom';
import {CampaignCreateModal} from '../../../../app/brand/campaign/briefing/modal/CampaignCreateModal';
import {ExitImpersonation} from '../../../../app/shared/impersonate/components/ExitImpersonation';
import {AuthService} from '../../../../authentication/service';
import {UserRoles} from '../../../../enum/UserRoles';
import {IUserNotification} from '../../../../model/campaign/Campaign';
import {IAllStates} from '../../../../store/rootReducer';
import {ErrorToast} from '../../../../utils/toasters';
import {CustomImageHandler} from '../../../components/CustomImageHandler';
import NotificationBell from '../../../components/NotificationBell';
import {getPackageColor} from '../../../functions/Functions';
import usePagination from '../../../hooks/usePagination';
import ProfileMenu from '../menu/ProfileMenu';
import {SideOverlay} from '../SideOverlay';


const Header = ({isProfileSideBarOpen, setProfileSideBar}: any) => {
    const [showBriefingModal, setShowBriefingModal] = useState(false);
    const [isNotificationsOpened, setIsNotificationsOpened] = useState(false);
    const {redDots} = useSelector((state: IAllStates) => state.redDots);
    const {
        user,
    } = useSelector((states: IAllStates) => states.auth);
    const [notificationList, setNotificationList] = useState<IUserNotification[]>([])
    const {t} = useTranslation();
    const location = useLocation();
    const {filterParams, setFilterParams} = usePagination({perPage: 50})
    const isBriefingOpen = location?.pathname?.includes('overview') || location?.pathname?.includes('step');
    const packageBorder = user.userType === UserRoles.INFLUENCER ? '' : `border border-2 border-${getPackageColor(user?.company?.package?.name)}`;

    const openProfile = () => {
        setProfileSideBar(!isProfileSideBarOpen);
    };
    const closeModal = () => setShowBriefingModal(false);
    const openModal = () => setShowBriefingModal(true);
    useEffect(() => {
        isNotificationsOpened && AuthService.getNotifications(filterParams)
            .then(response => {
                setNotificationList(response?.data)
            }).catch(err => ErrorToast(err))
    }, [isNotificationsOpened, filterParams]);

    useEffect(() => {
        if (redDots?.notifications) {
            setFilterParams((prev: any) => ({...prev, updatedAt: new Date()?.getTime()}))
        }
    }, [redDots?.notifications])
    return (
        <>
            <CampaignCreateModal show={showBriefingModal} closeModal={closeModal}/>
            <header>
                <Row className="w-100 m-0">
                    <Col lg={5} className="d-flex align-items-center">
                        <Link to="/">
                            <Image
                                alt="Influence vision logo"
                                src="/tempAssets/influence-vision-logo.svg"
                                height={60}
                                width={150}
                            />
                        </Link>
                        {/* <div className="d-flex mr-4">
                            <BreadCrumbs/>
                        </div> */}
                        <ExitImpersonation/>
                    </Col>
                    <Col
                        lg={7}
                        className="d-flex align-items-center justify-content-between justify-content-lg-end ml-auto"
                    >
                        {!(isBriefingOpen || ![UserRoles.BRAND_MASTER, UserRoles.BRAND].includes(user.userType as UserRoles)) &&
                            <Button variant="outline-primary"
                                    className={`mr-4`}
                                    onClick={openModal}
                                    size="sm"
                            >
                                {t('brand.create_new_campaign')}
                            </Button>}
                        {/*<div className="position-relative mr-4" ref={wrapperRef}>*/}

                        {/*    {isNotificationsOpened &&*/}

                        {/*</div>*/}
                        <NotificationBell setIsNotificationsOpened={setIsNotificationsOpened}
                                          isNotificationsOpened={isNotificationsOpened}
                                          setFilterParams={setFilterParams}
                                          notificationList={notificationList}/>
                        <div className="d-flex flex-lg-column align-items-end mr-3">
                            <div
                                className="mb-0">{[UserRoles.AGENCY, UserRoles.AGENCY_MASTER].includes(user.userType as UserRoles)
                                ? user?.agencyCompany?.displayName : user.company?.displayName}</div>
                            {(user.userType === UserRoles.BRAND_MASTER || user.userType === UserRoles.BRAND ||
                                    user.userType === UserRoles.AGENCY || user.userType === UserRoles.AGENCY_MASTER) &&
                                <div className="d-flex">
                                    {[UserRoles.BRAND_MASTER, UserRoles.AGENCY_MASTER].includes(user.userType) && (
                                        <span className="status pending mr-2 font-weight-normal">ADMIN</span>
                                    )}
                                    <h5 className="mb-0">{user.firstName} {user.lastName}</h5>
                                </div>
                            }
                            {/*<button*/}
                            {/*    className={`btn-sm btn-outline-secondary text-primary p-1 ml-3 ${(user.userType === UserRoles.BRAND
                            || user.userType === UserRoles.BRAND_MASTER) ? '' : 'd-none'}`}>*/}
                            {/*    <Image*/}
                            {/*        className="mr-1"*/}
                            {/*        src="/icons/img-starter-plan.png"*/}
                            {/*        alt="Darts icon"*/}
                            {/*    />*/}
                            {/*    {t('brand.starter_plan')}*/}
                            {/*</button>*/}
                            {user.userType === UserRoles.INFLUENCER &&
                                <>
                                    <h5 className="mb-0">{user.displayName}</h5>
                                    <div className="mb-0">{user.firstName} {user.lastName}</div>
                                </>
                            }
                        </div>
                        <div className="profile-img">
                            <CustomImageHandler
                                altTag="User Profile"
                                thumbnailPath={user?.profilePhoto?.thumbnail}
                                classes={packageBorder}
                                onClick={openProfile}
                                photoPath={`${user.profilePhoto?.path || user.profilePhoto?.thumbnail}`}
                            />
                        </div>
                    </Col>
                </Row>
            </header>
            <header className="mobile">
                <Link to="/">
                    <img width={34} height={34} src={'/icons/logoSmall.svg'} alt="Influence vision logo"/>
                </Link>
                <Button variant="outline-primary"
                        className={`${isBriefingOpen || ![UserRoles.BRAND_MASTER, UserRoles.BRAND].includes(user.userType as UserRoles) ? 'd-none' : null}`}
                        onClick={openModal}
                        size="sm"
                >
                    {t('brand.create_new_campaign')}
                </Button>
                <ExitImpersonation/>

                <div className="profile-img d-flex align-items-center">
                    <NotificationBell setIsNotificationsOpened={setIsNotificationsOpened}
                                      isNotificationsOpened={isNotificationsOpened} isMobile
                                      setFilterParams={setFilterParams}
                                      notificationList={notificationList}/>
                    <CustomImageHandler
                        altTag="User Profile"
                        onClick={openProfile}
                        classes={packageBorder}
                        photoPath={user.profilePhoto?.path as string}
                    />
                </div>
            </header>
            <SideOverlay
                isOpen={isProfileSideBarOpen}
                side={'right'}
                component={<ProfileMenu toggle={openProfile}/>}
            />
        </>
    );
};

export default Header;
